import { useEffect, useState } from "react";
import { RefreshCw, Activity } from "lucide-react";
import { Button } from "../ui/button";
import { api } from "@/lib/api";

export const STATUS = {
  sent: { label: "Enviado", cls: "bg-slate-100 text-slate-700" },
  delivery_delayed: { label: "Atrasado", cls: "bg-amber-100 text-amber-800" },
  delivered: { label: "Entregue", cls: "bg-green-100 text-green-800" },
  opened: { label: "Aberto", cls: "bg-teal-100 text-teal-800" },
  clicked: { label: "Clicado", cls: "bg-[#9B6179]/15 text-[#6F3F55]" },
  bounced: { label: "Rejeitado (bounce)", cls: "bg-red-100 text-red-800" },
  complained: { label: "Marcado como spam", cls: "bg-red-200 text-red-900" },
  failed: { label: "Falha no envio", cls: "bg-red-100 text-red-800" },
};

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "");

const LogRow = ({ l }) => {
  const s = STATUS[l.status] || STATUS.sent;
  return (
    <tr className="border-t border-[#9B6179]/5 align-top" data-testid={`email-log-row-${l.id}`}>
      <td className="px-3 py-2 text-xs text-[#8A7980] whitespace-nowrap">{fmt(l.created_at)}</td>
      <td className="px-3 py-2 text-xs">{(l.to || []).join(", ")}</td>
      <td className="px-3 py-2 text-xs">{l.subject}{l.error && <p className="text-red-700 mt-1">{l.error}</p>}</td>
      <td className="px-3 py-2"><span className={`text-[11px] px-2 py-0.5 rounded-[2px] whitespace-nowrap ${s.cls}`} data-testid={`email-log-status-${l.id}`}>{s.label}</span></td>
    </tr>
  );
};

export const DeliverabilityCard = () => {
  const [data, setData] = useState(null);
  const load = () => api.get("/admin/email-logs").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <div className="bg-white p-6 rounded-[2px] border border-[#9B6179]/5 space-y-4 mt-6" data-testid="deliverability-card">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-[#6F3F55]"><Activity className="w-4 h-4" /><p className="font-serif text-lg">Entregabilidade dos e-mails</p></div>
        <Button variant="outline" size="sm" className="rounded-[2px]" onClick={load} data-testid="deliverability-refresh"><RefreshCw className="w-3 h-3 mr-1" /> Atualizar</Button>
      </div>
      {data && !data.webhook_configured && <p className="text-xs text-amber-800 bg-amber-50 p-2" data-testid="webhook-not-configured">Webhook Resend não configurado: apenas os envios e as falhas são exibidos.</p>}
      {data && (
        <div className="flex flex-wrap gap-2" data-testid="deliverability-counts">
          {Object.entries(data.counts).map(([k, v]) => <span key={k} className={`text-xs px-2 py-1 rounded-[2px] ${(STATUS[k] || STATUS.sent).cls}`} data-testid={`deliverability-count-${k}`}>{(STATUS[k] || STATUS.sent).label}: {v}</span>)}
        </div>
      )}
      <div className="overflow-x-auto max-h-[480px] overflow-y-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#F7F0E8] text-[#6F3F55] text-xs uppercase sticky top-0"><tr><th className="text-left px-3 py-2">Data</th><th className="text-left px-3 py-2">Para</th><th className="text-left px-3 py-2">Assunto</th><th className="text-left px-3 py-2">Status</th></tr></thead>
          <tbody>{data?.logs.map((l) => <LogRow key={l.id} l={l} />)}</tbody>
        </table>
        {data && data.logs.length === 0 && <p className="text-sm text-[#8A7980] py-4 text-center" data-testid="deliverability-empty">Nenhum e-mail enviado ainda.</p>}
      </div>
    </div>
  );
};
